/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/298-volume-mute': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"/>'
  }
})
